import React from 'react'
import clsx from "clsx"

export default class ServiceLogPresenterRoom extends React.Component {
  constructor(props) {
    super(props)
  }

  render() {
    var tabClasses = clsx({
      'active': this.props.active_tab == "room",
      'tab-pane': true
    });

    var room = I18n.t('not_assigned')
    if (this.props.reservation_segment && this.props.reservation_segment.room) {
      room = this.props.reservation_segment.room
    } else if (this.props.reservation_segment && this.props.reservation_segment.room_group) {
      room = this.props.reservation_segment.room_group
    }

    return (
      <div className={tabClasses} id="room">
        <div className="row">
          <div className="col-sm-4 form-group">
            <label>{I18n.t('room_id_type')}</label>
              <br />
              <div>
                {this.props.reservation_segment
                ?
                <div>{this.props.reservation_segment.room ? this.props.reservation_segment.room.identifier : I18n.t('not_assigned')}</div>
                :
                <div>{this.props.service_log.room.identifier + ` (${this.props.service_log.room.room_type_name})`}</div>
                }
            </div>
          </div>
        </div>   
      </div>
    )
  }
}